<template>
  <div id="app">
    <points-mall v-if="isPointsMall" />
    <home v-else />
  </div>
</template>

<script>

import Home from '@/views/home'
import PointsMall from '@/views/pointsMall'
export default {
  name: 'App',
  components: { Home, PointsMall },
  data() {
    return { isPointsMall: new URLSearchParams(window.location.search).get('page_type') === 'points-mall' }
  }
}
</script>

<style>
@import "styles/normalize.css";
@import "styles/icon-fonts.css";
@import "styles/van-icon.css";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
